import Layout from '@components/layout/Main'
import Background from '@components/image/Background'
import ServiceSearchpageForm from '@components/search/forms/ServiceSearchpageForm'

import ViewContextProvider, { VIEWS } from '@context/ViewContext'
import BreadcrumbBar from '@components/breadcrumbs/BreadcrumbBar'
import Sort from '@components/select/Sort'
import State from '@components/select/State'
import View from '@components/select/View'

import AdList from '@components/lists/AdList'
import FAQ from '@components/shared/FAQ'
import LinkCubes from '@components/shared/LinkCubes'

import SeoHeadings from '@pages/search/SearchSeoHeadings'
import Seo from 'src/seo/components/Seo'
import JsonLdSearch from 'src/seo/jsonld/JsonLdSearch'

import dbConnect from 'db/dbConnect'
import listServiceAds from 'db/repo/listAds/listAdsService' //
import sessionCookies from '@utils/sessionCookies'
import useUrlSeo from 'src/seo/server/useUrlSeo'
import useSeoArticle from 'src/seo/components/articles/useSeoArticle'
import locationLdSchema from 'src/seo/jsonld/server/locationLdSchema'
import unslugify from '@utils/links/searchUnslugifyNumericParams'

const DEFAULT_HEADINGS = {
    h1: 'Warsztaty i serwisy samochodowe',
    h2: 'Szukasz warsztatu samochodowego a może ASO ? Sprawdź warsztaty samochodowe i serwisy ASO w Twojej okolicy na dostawczaki.pl',
}

export default function ServiceSearchpage ({ query, offers, pagination,
    seo, locationObjectLd }) {

    const [seoArticleExcerpt, seoArticleBody] = useSeoArticle(seo.articleFile)

    return (
        <Layout>
            <Seo seo={seo} offers={offers} />
            <JsonLdSearch
                baseUrl="/serwis-aut-dostawczych"
                buy={false}
                category="Serwisy samochodowe"
                locationObjectLd={locationObjectLd}
                offers={offers} />

            <Background
                collapseWhen="form_expands"
                height={264}
                src="/backgrounds/serwis-samochodowy-samochodow-osobowych-i-dostawczych.webp"
                alt="Serwis samocodowy samochodów osobowych i dostawczych"
                z={7}>

                <ServiceSearchpageForm query={query} />

            </Background>

            <ViewContextProvider defaultView={VIEWS.LIST}>
                <SeoHeadings seo={seo} defaultValues={DEFAULT_HEADINGS} />
                {seoArticleExcerpt}

                <BreadcrumbBar>
                    <State />
                    <Sort />
                    <View />
                </BreadcrumbBar>

                <AdList {...{
                    below: seoArticleBody,
                    offers,
                    pagination, }} />
            </ViewContextProvider>

            <LinkCubes {...{
                buy: false,
                rent: false,
                adtype: 'service_ad',
                query,
            }} />

            <FAQ qa={seo.faqFile} page="service_searchpage" />

        </Layout>
    )
}

export async function getServerSideProps (context) {
    await dbConnect()

    const query = unslugify(context.query)
    const cookies = sessionCookies(context)
    const { ads, pagination } = await listServiceAds(query, { cookies })
    return {
        props: {
            query,
            offers: ads,
            pagination,
            seo: await useUrlSeo({
                resolvedUrl: context.resolvedUrl,
                query,
                baseUrl: '/serwis-aut-dostawczych',
            }),
            locationObjectLd: locationLdSchema(query.lokalizacja),
        }
    }
}